import React from 'react';
import {reduxForm} from "redux-form";
import {createField, Input} from "../common/FormsControls/FormsControls";
import {required} from "../../utils/validators/validators";
import {connect} from "react-redux";
import {login} from "../../redux/auth-reducer";
import {Navigate} from "react-router-dom";
import style from "./../common/FormsControls/FormsControls.module.css"

const LoginForm = ({handleSubmit, error, captchaUrl}) => {
	// Field - компонент из библиотеки redux-form
	// handleSubmit , отмена события по умолчанию, сбор данных формы упаковка в объект, вызов onSubmit в контейнерной компоненте отправка объекта.
	return (
		<form onSubmit={handleSubmit}>
			{createField("Email", "email", [required], Input)}
			{createField("Password", "password", [required], Input, {type: "password"})}
			{createField(null, "rememberMe", [], Input, {type: "checkbox"}, "remember me")}

			{ captchaUrl && <img src={captchaUrl} alt="captcha" />}
			{ captchaUrl &&  createField("Symbols from image", "captcha", [required], Input, {}) }

			{error &&
				<div className={style.formSummaryError}>
					{error}
				</div>
			}
			<div>
				<button>Login</button>
			</div>
		</form>
	)
}

// форму оборачиваем в HOC reduxForm, из redux-form
const LoginReduxForm = reduxForm({form: 'login'})(LoginForm)

const Login = (props) => {

	const onSubmit = (formData) => {
		props.login(formData.email, formData.password, formData.rememberMe, formData.captcha);
	}

	if (props.isAuth) {
		return <Navigate to={"/profile"}/>
	}

	return <div>
		<h1>Login</h1>
		<LoginReduxForm onSubmit={onSubmit} captchaUrl={props.captchaUrl}/>
	</div>
}

const mapStateToProps = (state) => ({
	captchaUrl: state.auth.captchaUrl,
	isAuth: state.auth.isAuth
})

export default connect(mapStateToProps, {login})(Login);
